// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34gJE","colBig":"styles_colBig__34Ol8","colSmall":"styles_colSmall__2XjXN"};